exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth_image[data-v-c786ea00]{height:3rem;widows:9rem}", ""]);

// exports
